<template>
  <div>
    <nav class="navbar navbar-expand-lg navigation fixed-top sticky" id="navbar">
      <div class="container">
        <a class="navbar-logo" href="/">
          <img src="@/assets/images/logo-dark.png" alt height="28" class="logo logo-dark"/>
          <img src="@/assets/images/logo-light.png" alt height="28" class="logo logo-light"/>
        </a>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="/">{{ entidade.ent_nome }}</a>
          </li>
        </ul>
        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul class="navbar-nav ml-auto" id="topnav-menu">
            <li class="nav-item">
              <a class="nav-link" href="/">Início</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <section class="section hero-section bg-ico-hero" id="home">
      <div class="bg-overlay bg-primary"></div>
      <div class="container" style="margin-top: -6%">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-4">
                      <h5 class="text-primary">Confirmação de Conta</h5>
                      <p>Informe os dados para efetivar sua conta.</p>
                    </div>
                  </div>
                  <div class="col-5 align-self-end">
                    <img src="@/assets/images/profile-img.png" alt="Imagem" class="img-fluid"/>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <Loader v-if="user.tus_status !== 'A'" :loading="httpSend">
                  <b-form class="p-2" @submit.prevent="setConfirmacao">
                    <h5 class="mb-3">Dados Pessoais</h5>
                    <hr>
                    <b-form-group
                        id="pes_nome-group"
                        label="Nome Completo"
                        class="text-muted"
                        label-for="pes_nome-reply">
                      <input
                          id="pes_nome-reply"
                          v-model="user.pes_nome"
                          type="text"
                          maxlength="150"
                          class="form-control"
                          placeholder=""
                          :class="{'is-invalid': submitted && $v.user.pes_nome.$error,}">
                      <div v-show="$v.user.pes_nome.$error" class="text-danger">
                        Informe seu nome completo
                      </div>
                    </b-form-group>
                    <div class="text-left">
                      <h5 class="mb-3"><small class="text-muted">CPF: </small>{{ user.pes_cpfcnpj }}</h5>
                      <h5 class="mb-3"><small class="text-muted">E-mail: </small>{{ user.pes_mail }}</h5>
                    </div>
                    <h5 class="mb-3">Endereço</h5>
                    <hr>
                    <div class="row">
                      <div class="col-md-5">
                        <b-form-group
                            id="cep-group"
                            label="CEP"
                            class="text-muted"
                            label-for="cep-reply">
                          <input
                              id="cep-reply"
                              ref="inputCep"
                              v-on:focusout="buscaCEP(user.endereco.end_cep)"
                              v-model="user.endereco.end_cep"
                              v-mask="'##.###-###'"
                              type="text"
                              autocomplete="no"
                              maxlength="150"
                              class="form-control"
                              placeholder=" "
                              :class="{'is-invalid': errorCep || $v.user.endereco.end_cep.$error}">
                          <div v-show="errorCep" class="text-danger">
                            CEP não encontrado
                          </div>
                        </b-form-group>
                      </div>
                      <div class="col-md-7">
                        <b-form-group
                            id="cidade-group"
                            label="Cidade - UF"
                            class="text-muted"
                            label-for="cidade">
                          <h6 v-if="user.endereco.municipio.cidade" class="mb-3 mt-3">{{
                              user.endereco.municipio.cidade
                            }} -
                            {{ user.endereco.municipio.uf }}</h6>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-8">
                        <b-form-group
                            id="quadra-group"
                            label="Endereço/Quadra"
                            class="text-muted"
                            label-for="quadra">
                          <input
                              id="quadra"
                              ref="inputEndereco"
                              v-model="user.endereco.end_logradouro"
                              type="text"
                              maxlength="200"
                              class="form-control"
                              placeholder=" "
                              :class="{'is-invalid': submitted && $v.user.endereco.end_logradouro.$error,}">
                          <div v-show="$v.user.endereco.end_logradouro.$error" class="text-danger">
                            Informe seu endereço
                          </div>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                            id="lote-group"
                            label="Número/Lote"
                            class="text-muted"
                            label-for="lote">
                          <input
                              id="lote"
                              ref="inputNumero"
                              v-model="user.endereco.end_numero"
                              type="text"
                              maxlength="10"
                              class="form-control"
                              placeholder=" "
                              :class="{'is-invalid': submitted && $v.user.endereco.end_numero.$error,}">
                          <div v-show="$v.user.endereco.end_numero.$error" class="text-danger">
                            Número
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-7">
                        <b-form-group
                            id="bairro-group"
                            label="Bairro"
                            class="text-muted"
                            label-for="cep-reply">
                          <input
                              id="bairro"
                              v-model="user.endereco.end_bairro"
                              type="text"
                              maxlength="100"
                              class="form-control"
                              placeholder=" "
                              :class="{'is-invalid': submitted && $v.user.endereco.end_bairro.$error,}">
                          <div v-show="$v.user.endereco.end_bairro.$error" class="text-danger">
                            Informe o bairro
                          </div>
                        </b-form-group>
                      </div>
                      <div class="col-md-5">
                        <b-form-group
                            id="complemento-group"
                            label="Complemento"
                            class="text-muted"
                            label-for="complemento">
                          <input
                              id="complemento"
                              v-model="user.endereco.end_complemento"
                              type="text"
                              maxlength="100"
                              class="form-control"
                              placeholder=" ">
                        </b-form-group>
                      </div>
                    </div>
                    <div class="mt-4">
                      <b-button type="submit" variant="primary"
                                class="btn-block">Concluir Conta
                      </b-button>
                    </div>
                  </b-form>
                  <div role="alert" v-show="resposta.status" aria-live="polite" aria-atomic="true"
                       class="alert alert-success mt-2">
                    <i class="mdi mdi-check-all mr-2"></i> {{ resposta.mensagem }}
                    <router-link
                        tag="a"
                        to="/"
                        class="font-weight-medium text-primary">Login
                    </router-link>
                  </div>
                  <div role="alert" v-show="resposta.status === false" aria-live="polite" aria-atomic="true"
                       class="alert alert-danger mt-2">
                    <i class="mdi mdi-block-helper mr-2"></i> {{ resposta.mensagem }}
                  </div>
                  <div role="alert" v-show="user.tus_status === 'A'" aria-live="polite" aria-atomic="true"
                       class="alert alert-warning mt-2">
                    <i class="mdi mdi-check-all mr-2"></i> Sua conta já foi confirmada. Acesse a página de login para
                    acesser o sistema.
                    <router-link
                        tag="a"
                        to="/"
                        class="font-weight-medium text-primary">Login
                    </router-link>
                  </div>
                </Loader>
                <div role="alert" v-show="user.tus_status === 'A'" aria-live="polite" aria-atomic="true"
                     class="alert alert-success mt-2">
                  <i class="mdi mdi-check-all mr-2"></i> Sua conta já foi confirmada. Acesse a página de login para
                  acesser o sistema.
                  <router-link
                      tag="a"
                      to="/"
                      class="font-weight-medium text-primary">Login
                  </router-link>
                </div>
              </div>
            </div>
            <!-- end card -->
            <div class="mt-5 text-center text-white">
              <p>
                Já possui conta ?
                <router-link
                    tag="a"
                    to="/"
                    class="font-weight-medium text-danger">Login
                </router-link>
              </p>
            </div>
          </div>
          <!-- end col -->
        </div>
      </div>
    </section>
    <footer class="landing-footer">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-md-5">
            <div class="mb-4">
              <img src="@/assets/images/logo-light.png" alt height="20"/>
            </div>
            <p class="mb-2">{{ entidade.ent_nome }}</p>
            <p class="mb-2">CNPJ: {{ entidade.ent_cnpj | VMask('##.###.###/####-##') }}</p>
            <p class="mb-2">Telefone: {{ entidade.ent_telefone1 | VMask('(##) #### ####?#') }}</p>
            <p>
              {{ entidade.ent_endereco }} {{ entidade.ent_numero }}, {{ entidade.ent_bairro }}<br>
              {{ entidade.mun_nome }} - {{ entidade.mun_uf }}<br>
              CEP: {{ entidade.ent_cep | VMask('##.###-###') }}
            </p>
          </div>
          <div class="col-md-4">
            <div class="mb-4">
              <img src="http://www.dattasystem.com.br/portal/img/logo.png"/>
            </div>
            <p class="mb-2">{{ new Date().getFullYear() }} © DattaNFSe</p>
            <p class="mb-2">Desenvolvimento</p>
            <p class="mb-2">Datta System Tecnologia</p>
          </div>
        </div>
      </div>
      <!-- end container -->
    </footer>
  </div>
</template>
<script>
import {getIndex} from "@/api/core";

const zxcvbn = require('zxcvbn');
import axios from "axios";
import {required} from "vuelidate/lib/validators";
import appConfig from "@/dados/app.config.json";
import Loader from "@/components/widgets/loader"
import {soNumeros} from "@/helps/util"
import {getConfirmacao, setConfirmacao} from "@/api/login/auth"

export default {
  page: {
    title: "Confirmação",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader
  },
  data() {
    return {
      entidade: {},
      user: {
        tus_codigo: "",
        pes_cpfcnpj: "",
        tus_status: null,
        pes_mail: "",
        pes_nome: "",
        endereco: {
          end_cep: '',
          end_logradouro: '',
          end_bairro: '',
          end_numero: '',
          end_complemento: '',
          municipio: {
            uf: '',
            cidade: '',
            mun_codigo: ''
          }
        }
      },
      resposta: {
        status: null,
        mensagem: ''
      },
      httpSend: false,
      errorCep: false,
      submitted: false
    };
  },
  validations: {
    user: {
      pes_nome: {
        required,
      },
      endereco: {
        end_bairro: {
          required,
        },
        end_numero: {
          required,
        },
        end_logradouro: {
          required,
        },
        end_cep: {
          required,
        }
      }
    },
  },
  created() {
    this.getEntidade();
    this.getConfirmacao();
  },
  computed: {
    passwordStrength() {
      return zxcvbn(this.user.aut_senha);
    },
    senhaDiferentes() {
      return (this.user.aut_senha !== this.user.aut_senha_reply);
    }
  },
  methods: {
    getEntidade() {
      getIndex().then(response => {
        if (response.status) {
          this.entidade = response.dados.parametros;
        }
      }).catch(error => {
        console.log(error)
      })
    },
    buscaCEP(CEP) {
      this.httpSend = true;
      this.errorCep = false;
      axios.get(`https://viacep.com.br/ws/${soNumeros(CEP)}/json/`, {}).then((res) => {
        if (res.status === 200) {
          if (Object.prototype.hasOwnProperty.call(res.data, 'erro')) {
            this.$refs.inputCep.focus();
            this.errorCep = true;
            this.user.endereco.municipio.uf = '';
            this.user.endereco.municipio.cidade = '';
            this.user.endereco.municipio.mun_codigo = null;
            this.user.endereco.end_bairro = '';
            this.user.endereco.end_logradouro = '';
          } else {
            this.errorCep = false;
            this.user.endereco.municipio.uf = res.data.uf;
            this.user.endereco.municipio.cidade = res.data.localidade;
            this.user.endereco.municipio.mun_codigo = res.data.ibge;
            this.user.endereco.end_bairro = res.data.bairro;
            this.user.endereco.end_logradouro = res.data.logradouro;
            if (this.user.endereco.end_logradouro) {
              this.$refs.inputNumero.focus();
            } else {
              this.$refs.inputEndereco.focus()
            }
          }
        }
      }).catch(error => {
        console.log(error);
        this.errorCep = true;
        this.user.endereco.municipio.uf = '';
        this.user.endereco.municipio.cidade = '';
        this.user.endereco.municipio.mun_codigo = null;
      }).finally(() => {
        this.httpSend = false
      })
    },
    getConfirmacao() {
      this.httpSend = true;
      getConfirmacao(this.$route.params.tus_codigo).then(response => {
        this.user.pes_cpfcnpj = response.dados.tus_cpfcnpj
        this.user.pes_mail = response.dados.tus_mail
        this.user.tus_status = response.dados.tus_status
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false
      })
    },
    setConfirmacao() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if (!this.user.endereco) {
          this.$toast.error("Verifique se o endereço foi digitado corretamente")
          return;
        }
        if (!this.user.endereco.municipio) {
          this.$toast.error("Verifique se o CEP foi digitado corretamente. Não utilize o autocompletar do navegador")
          return;
        }
        if (!this.user.endereco.municipio.mun_codigo) {
          this.$toast.error("Verifique se o CEP foi digitado corretamente. Não utilize o autocompletar do navegador")
          return;
        }
        this.httpSend = true;
        this.user.tus_codigo = this.$route.params.tus_codigo;
        setConfirmacao(this.user).then(response => {
          this.resposta = response;
          if (response.status) {
            this.$toast.success(response.mensagem);
            setTimeout(function () {
              this.$router.push({name: 'index'})
            }.bind(this), 4000)
          } else {
            this.$toast.error(response.mensagem)
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.httpSend = false
        })
      }
    },
  },
};
</script>


<style lang="scss" module></style>
